import React from 'react'
import { HeaderCenter, HeaderRight, HeaderWrapper } from './index.styled'
import Logo from '../Elements/Logo'
import Language from '../Language'
import ButtonsLogin from './buttonsLogin'
import { theme } from '../../style/theme'
import { useWindowBreakPoint } from '../../hooks/useWindowBreakPoint'

const PublicHeader = React.memo(() => {
	const isTablet = useWindowBreakPoint(theme.point820)

	return (
		<HeaderWrapper className="authPage">
			<HeaderCenter className={isTablet ? 'authPage' : ''}>
				<Logo />
			</HeaderCenter>
			<HeaderRight className="lf-hidden" id="header-right">
				{!isTablet && <ButtonsLogin />}
				{!isTablet && <Language />}
			</HeaderRight>
		</HeaderWrapper>
	)
})

PublicHeader.displayName = 'PublicHeader'
export default PublicHeader
